<template>
    <modal-cadu close :width="600" style="overflow: hidden;" v-model="valueData">
        <div slot="all">
            <div slot="body">
                <div class="pa-6">
                    <v-row no-gutters align="center" justify="center" class="icon-wrn">
                        <v-col cols="auto">
                            <icon name="alert-triangle" :size="50" />
                        </v-col>
                    </v-row>
                    <v-row no-gutters align="center" justify="center" class="icon-wrn my-4">
                      <v-col cols="auto" class="title mx-4">
                            UNIMED INATIVA!
                        </v-col>
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>Código Unimed</b>:  {{errObj.codigo}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>Nome Fantasia</b>:  {{errObj.nomeFantasia}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>Razão Social</b>:  {{errObj.razaoSocial}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>CNPJ</b>:  {{errObj.cnpj}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>Tipo de Cooperativa</b>:  {{errObj.tipoUnimed}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>Tipo de Atuação</b>:  {{errObj.tipoAtuacao}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>UF</b>:  {{errObj.uf}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>Data de Extinção</b>:  {{errObj.dataExtincao}}
                    </v-row>
                    <v-row class="d-block" no-gutters align="center" justify="start">
                            <b>Observação</b>:  {{errObj.motivoExtincao}}
                    </v-row>
                </div>
            </div>
        </div>
    </modal-cadu>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    errObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valueData: this.value
    }
  },
  watch: {
    value() {
      this.valueData = this.value
    },
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style lang="sass">
.icon-wrn
    color: #ED1651

.title
    font-size: 4em
    font-weight: bold

.v-alert__icon
    height: auto !important
</style>
